import * as ACTIONS from '../../constants/module-selection-constants';

export const updateMethodology = data => ({ type: ACTIONS.UPDATE_METHODOLOGY, payload: data });
export const updateUniverse = data => ({ type: ACTIONS.UPDATE_UNIVERSE, payload: data });
export const removeMethodology = () => ({ type: ACTIONS.REMOVE_METHODOLOGY });
export const removeUniverse = () => ({ type: ACTIONS.REMOVE_UNIVERSE });
export const resetAll = () => ({ type: ACTIONS.RESET_ALL });
